import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const InternalAdminLogo = (props: IconProps) => (
  <Icon w="204px" h="32px" viewBox="0 0 204 32" {...props}>
    <path
      fill="url(#a)"
      d="M24.2667 11.5H8.05334C5.81499 11.5 4 13.2911 4 15.5s1.81499 4 4.05334 4H24.2667c2.2383 0 4.0533 1.7911 4.0533 4v-8c0-2.2089-1.815-4-4.0533-4Z"
    />
    <path
      fill="url(#b)"
      d="M24.2665 19.5h-8.1067c-2.2384 0-4.0534 1.7911-4.0534 4v8c0-2.2089 1.815-4 4.0534-4h8.1067c2.2383 0 4.0533-1.7911 4.0533-4s-1.815-4-4.0533-4Z"
    />
    <path
      fill="url(#c)"
      d="M8.05334 3.5C5.81499 3.5 4 5.29111 4 7.5v8c0-2.2089 1.81499-4 4.05334-4H16.16c2.2383 0 4.0533-1.79111 4.0533-4v-4H8.05334Z"
    />
    <path d="M39.368 22V9.4h2.07V22h-2.07Zm5.6988 0V9.4h1.44l.63 2.376V22h-2.07Zm8.73 0-7.542-9.846.252-2.754 7.542 9.846-.252 2.754Zm0 0-.63-2.214V9.4h2.07V22h-1.44Zm8.2404 0V9.76h2.07V22h-2.07Zm-4.104-10.71V9.4h10.278v1.89h-10.278ZM70.9137 22V9.4h2.07V22h-2.07Zm1.422 0v-1.89h7.056V22h-7.056Zm0-5.526v-1.818h6.444v1.818h-6.444Zm0-5.184V9.4h6.966v1.89h-6.966Zm11.5172 5.364v-1.71h3.186c.636 0 1.128-.162 1.476-.486.36-.336.54-.798.54-1.386 0-.528-.174-.972-.522-1.332-.348-.36-.84-.54-1.476-.54h-3.204V9.4h3.294c.792 0 1.488.162 2.088.486.6.312 1.062.744 1.386 1.296.336.54.504 1.158.504 1.854 0 .732-.168 1.368-.504 1.908-.324.54-.786.96-1.386 1.26-.6.3-1.296.45-2.088.45h-3.294ZM82.4309 22V9.4h2.07V22h-2.07Zm6.912 0-4.41-5.472 1.926-.702L91.9529 22h-2.61Zm5.0446 0V9.4h1.44l.63 2.376V22h-2.07Zm8.7305 0-7.5425-9.846.252-2.754 7.5425 9.846-.252 2.754Zm0 0-.63-2.214V9.4h2.07V22h-1.44Zm4.136 0 5.184-12.6h1.44l5.148 12.6h-2.232l-4.032-10.206h.756L109.45 22h-2.196Zm2.556-2.43v-1.8h6.678v1.8h-6.678ZM121.588 22V9.4h2.07V22h-2.07Zm1.422 0v-1.89h6.588V22h-6.588Zm12.292 0 5.184-12.6h1.44l5.148 12.6h-2.232l-4.032-10.206h.756L137.498 22h-2.196Zm2.556-2.43v-1.8h6.678v1.8h-6.678Zm13.2 2.43v-1.89h3.312c.864 0 1.62-.186 2.268-.558.66-.372 1.17-.888 1.53-1.548.372-.672.558-1.446.558-2.322 0-.864-.186-1.626-.558-2.286-.372-.66-.888-1.176-1.548-1.548-.648-.372-1.398-.558-2.25-.558h-3.312V9.4h3.366c.912 0 1.758.162 2.538.486.78.312 1.458.756 2.034 1.332.588.564 1.044 1.23 1.368 1.998.324.756.486 1.584.486 2.484 0 .888-.162 1.716-.486 2.484-.324.768-.774 1.44-1.35 2.016-.576.564-1.254 1.008-2.034 1.332-.78.312-1.62.468-2.52.468h-3.402Zm-1.422 0V9.4h2.07V22h-2.07Zm14.224 0V9.4h1.44l5.238 8.622h-.936L174.84 9.4h1.44V22h-2.07v-8.964l.468.126-3.888 6.39h-1.44l-3.888-6.39.468-.126V22h-2.07Zm16.052 0V9.4h2.07V22h-2.07Zm5.699 0V9.4h1.44l.63 2.376V22h-2.07Zm8.73 0-7.542-9.846.252-2.754 7.542 9.846-.252 2.754Zm0 0-.63-2.214V9.4h2.07V22h-1.44Z" />
    <defs>
      <linearGradient
        id="a"
        x1="4"
        x2="28.32"
        y1="17.5"
        y2="17.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F16431" />
        <stop offset="0.36" stopColor="#F68F1D" />
        <stop offset="0.79" stopColor="#FCBD08" />
        <stop offset="1" stopColor="#FFCF00" />
      </linearGradient>
      <linearGradient
        id="b"
        x1="12.1064"
        x2="28.3198"
        y1="25.5"
        y2="25.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F16431" />
        <stop offset="0.34" stopColor="#EE6130" />
        <stop offset="0.56" stopColor="#E85830" />
        <stop offset="0.75" stopColor="#DC492F" />
        <stop offset="0.91" stopColor="#CC352D" />
        <stop offset="1" stopColor="#C1272D" />
      </linearGradient>
      <linearGradient
        id="c"
        x1="4"
        x2="20.2133"
        y1="9.5"
        y2="9.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF9500" />
        <stop offset="0.09" stopColor="#FFA900" />
        <stop offset="0.19" stopColor="#FFBA00" />
        <stop offset="0.32" stopColor="#FFC600" />
        <stop offset="0.5" stopColor="#FFCD00" />
        <stop offset="1" stopColor="#FFCF00" />
      </linearGradient>
    </defs>
  </Icon>
);

export default memo(InternalAdminLogo);
